module.exports = __webpack_public_path__ + "static/proweek-presentation-cbe3acdb19f3261c705b0e47bec9732e.png";